import Bugsnag from "@bugsnag/js";
import classNames from "classnames";
import { FunctionComponent, useState } from "react";
import Tag from "@Components/atoms/Tag";
import { Section, Tile } from "@Types/pagify";
import { getLabelIcon } from "@Utils/pagify";
import "./style.scss";

export const ProductImagesGallery: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  const [selectedImageId, setSelectedImageId] = useState<number>(0);

  if (tiles.length === 0) {
    Bugsnag.notify(new Error(`No tile found in ProductImagesCarousel`));
    return null;
  }

  const label = tiles[0].label;
  const LabelIcon = label ? getLabelIcon(label.labelType) : null;

  const imagesList = tiles.map((tile, id) => {
    return (
      tile.images.length > 0 && {
        id,
        urls: tile.images[0].desktop,
      }
    );
  });

  if (imagesList.length === 0) {
    Bugsnag.notify(new Error(`No images found in ProductImagesCarousel`));
    return null;
  }

  return (
    <div className="ProductImagesGallery">
      <div className="ProductImagesGallery-container">
        {label && (
          <div className="ProductImagesGallery-label">
            <Tag backgroundColor={label.color.hex} size="m">
              {LabelIcon && <LabelIcon />}
              {label.text}
            </Tag>
          </div>
        )}
        {imagesList.map((image, index) => {
          if (!image) return null;

          const imageKey = `${section.title || tiles[0].slug} Cheerz ${index + 1}`;

          return (
            <img
              alt={imageKey}
              className={classNames("ProductImagesGallery-image", {
                "ProductImagesGallery-image--selected": image.id === selectedImageId,
              })}
              height={437}
              key={imageKey}
              src={image.urls["1x"]}
              srcSet={`${image.urls["1x"]} 1x, ${image.urls["2x"]} 2x`}
              width={437}
            />
          );
        })}
      </div>
      <div className="ProductImagesGallery-thumbs">
        {imagesList.map((image, index) => {
          if (!image) return null;

          const thumbKey = `${section.title || tiles[0].slug} Cheerz mini-${index + 1}`;

          return (
            <div
              className={classNames("ProductImagesGallery-thumb", {
                "ProductImagesGallery-thumb--selected": image.id === selectedImageId,
              })}
              key={thumbKey}
              onClick={() => setSelectedImageId(index)}
            >
              <img
                alt={thumbKey}
                className="ProductImagesGallery-thumb-image"
                height={53}
                src={image.urls["1x"]}
                srcSet={`${image.urls["1x"]} 1x, ${image.urls["2x"]} 2x`}
                width={53}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
